
import {useProducts} from './use-products';
import {Button} from '../../ui/buttons/button';
import {Trans} from '../../i18n/trans';
import {ForumIcon} from '../../icons/material/Forum';
import {Navbar} from '../../ui/navigation/navbar/navbar';
import {Link} from 'react-router-dom';
import {Footer} from '../../ui/footer/footer';
import {useState} from 'react';
import {UpsellBillingCycle} from './find-best-price';
import {BillingCycleRadio} from './billing-cycle-radio';
import {StaticPageTitle} from '../../seo/static-page-title';
import {PricingTable} from '@common/billing/pricing-table/pricing-table';
import {useAuth} from '@common/auth/use-auth';
import { useToggleSidebar } from '@app/contexts/toggleSidebar';
export function PricingPage() {
  const query = useProducts();
  const {isLoggedIn} = useAuth();
  console.log("isLoggedIn", isLoggedIn);
  const {isdarkMode} = useToggleSidebar();
  const [selectedCycle, setSelectedCycle] =
    useState<UpsellBillingCycle>('yearly');

  return (
    <>
<header id="header-wrap" className="w-full relative">
            <nav className="fixed top-0 left-0 px-10 w-full z-30 duration-300 px-5 bg-white shadow flex items-center justify-between">
                <div className="flex justify-between items-center ">
                    <Link className="navbar-brand inline-block mx-5" to="/">
                        <img className="w-16 h-16 md:w-16 md:h-16" src="./images/cc.png" alt="Logo" />
                    </Link>
                </div>


                <div className="flex items-center lg:order-2">
                {isLoggedIn == false ? (<Link target="_blank" to="/login"
                        className="text-white bg-primary hover:bg-primary/90 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-4 lg:px-10 py-2 lg:py-2.5 sm:mr-2 lg:mr-0 dark:bg-primary ">Sign In</Link>) : (
                        <Link className="text-white bg-primary hover:bg-primary/90 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-4 lg:px-10 py-2 lg:py-2.5 sm:mr-2 lg:mr-0 dark:bg-primary " to="/drive">My File</Link>
                        )}
                    <button data-collapse-toggle="mobile-menu-2" type="button"
                        className="inline-flex items-center ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                        aria-controls="mobile-menu-2" aria-expanded="false">
                        <span className="text-2xl cursor-pointer mx-2 md:hidden block">
                            {/* <ion-icon name="menu" onclick="Menu(this)"></ion-icon> */}
                        </span>
                    </button>
                </div>


                <ul className=" md:flex md:items-center z-[-10] md:z-auto md:static uppercase absolute bg-white w-full left-0
                md:w-auto md:py-0 py-4 md:pl-0 pl-7 md:opacity-100 opacity-0 top-[-400px] transition-all ease-in
                duration-500">
                    <li>
                        <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
                            <li>
                                <Link to="/"
                                    className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0 "
                                    aria-current="page">HOME</Link>
                            </li>
                            <li>
                                <Link to="/offering"
                                    className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0 "
                                    aria-current="page">OFFERINGS</Link>
                            </li>
                            <li>
                                <Link to="/aboutus"
                                    className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0 "
                                    aria-current="page">ABOUT US</Link>
                            </li>
                            <li>
                                <Link to="/features"
                                    className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0 ">
                                    FEATURES</Link>
                            </li>
                            <li>
                                <Link target="_blank" to="/pricing"
                                    className="block py-2 pl-3 pr-4 text-white bg-primary rounded lg:bg-transparent lg:text-primary lg:p-0 dark:text-white ">
                                    PRICING & PLAN</Link>
                            </li>
                            <li>
                                <Link to="/contact"
                                    className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0 ">
                                    CONTACT</Link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </header>

     {/* <header className=" w-full">
        <nav className="bg-white border-gray-200 py-2.5 ">
            <div className="flex flex-wrap items-center justify-between max-w-screen-xl px-4 mx-auto">
                <Link
                to="/"
                className=
                  'block mr-4 md:mr-24 flex-shrink-0 h-full'
                
              >
                <img
                  className="block"
                  data-logo="navbar"
                  src="./images/logo.png"
                  width="102px"
                
                />
              </Link>
            
                <div className="flex items-center lg:order-2">
                    
                    <Link to="/login" className="text-white bg-primary hover:bg-primary/90 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 sm:mr-2 lg:mr-0 dark:bg-primary ">Sign In</Link>
                    <button data-collapse-toggle="mobile-menu-2" type="button" className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="mobile-menu-2" aria-expanded="false">
                        <span className="sr-only">Open main menu</span>
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
                        <svg className="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                    </button>
                </div>
                <div className="items-center justify-between hidden w-full lg:flex lg:w-auto lg:order-1" id="mobile-menu-2">
                    <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
                        <li>
                            <Link to="/" className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0" aria-current="page">Home</Link>
                        </li>
                        <li>
                            <Link to="/features" className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0 ">Features</Link>
                        </li>
                        <li>
                            <Link to="/pricing" className="block py-2 pl-3 pr-4 text-white  rounded lg:bg-transparent lg:text-primary lg:p-0 dark:text-white">Pricing &amp; Plan</Link>
                        </li>
                        <li>
                            <Link to="/contact" className="block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary lg:p-0 ">Contact</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </header> */}
   
    <div className="pt-10 flex flex-col h-full overflow-auto">
      <StaticPageTitle>
        <Trans message="Pricing" />
      </StaticPageTitle>
     
      {/* <Navbar
        color="bg"
        darkModeColor="transparent"
        border="border-b"
        className="flex-shrink-0"
        menuPosition="pricing-table-page"
      /> */}
      <div className="row mx-auto px-24 flex-auto ">
        <h1 className="text-3xl md:text-4xl text-center mt-30 md:mt-60 mb-30 font-normal md:font-medium">
          <Trans message="Choose the right plan for you" />
        </h1>

        {/* <BillingCycleRadio
          products={query.data?.products}
          selectedCycle={selectedCycle}
          onChange={setSelectedCycle}
          className="mb-40 md:mb-70 flex justify-center"
          size="lg"
        /> */}

        <PricingTable selectedCycle={selectedCycle} />
        {/* <ContactSection /> */}
      </div>
                
<footer className="relative z-10 bg-primary text-white pt-20 md:px-12 lg:pt-[75px]">
<div className="elementor-divider">
			<span className="elementor-divider-separator">
						</span>
		</div>
  <div className=" mx-auto px-6 lg:px-2">
 
    <div className="-mx-4 flex md:mx-4 flex-wrap">
      <div className="px-6 sm:w-2/3 lg:w-1/4 ">
        <div className="w-full">
        <div className='flex flex-wrap -mx-1 lg:-mx-8'>
          <img className="md:w-1/2 h-33 w-auto mb-4 object-contain" src="/images/cclogo.svg" alt="" />
         
         
          </div>
          <p className="font-normal text-justify my-4 text-base ">CONIACLOUD, the IT solution for stable, customized, and secure cloud storage solutions. Secure and protect your data with ease, ensuring accessibility and seamless sharing with other users at any time. Experience the state-of-the-art storage technology offered by CONIACLOUD and elevate your data management to new heights.</p>
        </div>
      </div>
      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg-footer font-semibold">Quick Links</h4>

          <ul className="space-y-4 mt-5">
            <li className="flex items-center flex-wrap flex-row">
              <Link to="/" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">Home
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="/features"  className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                Features
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="/pricing" target='_blank' className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Plans & Pricing
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="/contact" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Contact Us
              </Link>
            </li>

          </ul>
        </div>
      </div>
      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg-footer font-semibold">Services</h4>

          <ul className="space-y-4 mt-5">
            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                Shared Web
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                Hosting
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                VPS Hosting
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Dedicated Server
              </Link>
            </li>


            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Cloud Hosting
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Domain Names
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                License Keys
              </Link>
            </li>

          </ul>
        </div>
      </div>
      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg-footer font-semibold">Contact Us</h4>

          <ul className="space-y-4 mt-5">
          <li className="flex items-center flex-wrap flex-row">
          CONIACLOUD
            </li>

            <li className="flex items-center flex-wrap flex-row">
            Aşkan Mahallesi, Şahane Sk. No: 36 b
42090 Konya – Meram, Türkiye

            </li>
            
            <li className="flex items-center flex-wrap flex-row">
            Phone:&nbsp;<Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
              +90 332 300 00 11
              </Link>
            </li>
            
            <li className="flex items-center flex-wrap flex-row">
            E-mail:&nbsp; <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
            Support@CONIACLOUD.com
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row mt-20">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Follow Us
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <div className="flex mt-10 lg:mt-0  items-center space-x-6">
              <a target='_blank' href="https://www.linkedin.com/company/coniasoft/"><img src="images/linkedin1.png" alt="LinkedIn" className="w-8"/></a>
              <a target='_blank' href="https://www.facebook.com/profile.php?id=100092460917308"><img src="images/facebook1.png" alt="facebook" className="w-8 "/></a>
              <a target='_blank' href="https://twitter.com/ConiaSoft"><img src="images/twitter1.png" alt="Twitter" className="w-8"/></a>
              <a target='_blank' href="https://www.instagram.com/coniasoft/"><img src="images/insta.png" alt="InstaGram" className="w-8"/></a>
                   
             
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>

  </div>
  <div className="elementor-divider_bottom">
			<span className="elementor-divider-separator">
						</span>
		</div>
<footer className="mb-4">

  <div className={`px-10 py-5 ${isdarkMode?"bg-[#202124]": "bg-[#006cb6]"} flex flex-col md:flex-row lg:flex-row mb-0 lg:mt-0 items-center justify-between`}>
    <div className="flex lg:space-x-6  lg:flex-row flex-col text-center">
    <p className="text-[#FFFFFF] font-regular text-[14px] leading-2">Ⓒ 2023 - 2025 All Rights Reserved. Designed & Developed by <Link className='createdby' target='_blank' to="https://coniacloud.com/"><b>ConiaSoft Ⓡ Software Technologies Limited.</b></Link> </p>
     
    </div>
    {/* <div className="flex mt-10 lg:mt-0  items-center space-x-2">
      <p className="text-[#FFFFFF] font-regular text-[14px] leading-2"><Link to='https://coniacloud.com/privacy'>Privacy Policy</Link> &nbsp;</p>
     
    </div> */}
  </div>
</footer>
</footer>

    </div>
    
    </>
  );
}

function ContactSection() {
  return (
    <div className="p-24 text-center my-20 md:my-80">
      <ForumIcon size="xl" className="text-muted" />
      <div className="md:text-lg my-8">
        <Trans message="Do you have any questions about PRO accounts?" />
      </div>
      <div className="mb-24 text-sm md:text-base mt-20 md:mt-0">
        <Trans message="Our support team will be happy to assist you." />
      </div>
      <Button variant="flat" color="primary" elementType={Link} to="/contact">
        <Trans message="Contact us" />
      </Button>
    </div>
  );
}
